"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../../utils");
var _Knocks = require("@studio/constants/Knocks");
var _Sources = require("@studio/constants/Sources");
var _Banners = require("@studio/constants/Banners");
var _Permissions = require("@studio/constants/Permissions");
var _index = require("./index");
var _createOrUpdateSource = _interopRequireDefault(require("../source/createOrUpdateSource"));
var _SocketEvents = require("../../constants/SocketEvents");
var _types = require("./types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Action creator to approve all pending knock requests for a broadcast.
 *
 * This function creates a thunk that:
 * - Retrieves all pending knocks (both regular knocks and director requests)
 * - Filters out screenshare requests if screen share slots are not available
 * - Sends approval requests to the API for each valid knock
 * - Emits socket events to notify presenters of approval
 * - Dispatches clearKnock action to remove approved knocks from the state
 *
 * The function handles both presenter and screenshare knock requests, ensuring that
 * screenshare requests are only approved if there are available screenshare slots.
 *
 * @function approveAllKnocks
 * @returns {Function} Redux thunk that dispatches the approve all knocks action
 *
 * @example
 * // Dispatch the action to approve all pending knocks
 * dispatch(approveAllKnocks());
 *
 * @see {@link clearKnock} - Action to clear approved knocks from state
 * @see {@link getShouldApproveScreenShares} - Utility to check if screenshares can be approved
 */
var approveAllKnocks = function approveAllKnocks() {
  return function (dispatch, getState, socket) {
    var _getState = getState(),
      sources = _getState.broadcastSources.sources,
      banners = _getState.banners,
      _getState$broadcastRe = _getState.broadcastRecordings,
      broadcastRecordings = _getState$broadcastRe === void 0 ? {} : _getState$broadcastRe,
      streamEndpoints = _getState.broadcastStreamEndpoints,
      attendeeRoster = _getState.attendeeRoster,
      program = _getState.program,
      knocks = _getState.knocks,
      directorRequests = _getState.directorRequests,
      team = _getState.team,
      broadcastSettings = _getState.broadcastSettings;
    var _broadcastRecordings$ = broadcastRecordings.liveRecordings,
      liveRecordings = _broadcastRecordings$ === void 0 ? [] : _broadcastRecordings$;
    var match = (0, _utils.getBroadcastRouteMatch)(getState);
    var _match$params = match.params,
      broadcastId = _match$params.broadcastId,
      teamId = _match$params.teamId,
      eventId = _match$params.eventId;
    var pendingKnocks = [].concat(_toConsumableArray(knocks), _toConsumableArray(directorRequests)).filter(function (_ref) {
      var status = _ref.status;
      return status === _Knocks.PENDING;
    });
    var shouldApproveScreenshares = (0, _utils.getShouldApproveScreenShares)(pendingKnocks, sources);
    var presenterBanner = banners.find(function (banner) {
      return banner.source.value.templateType === _Banners.PRESENTER_BANNER;
    });
    var hasChatAccess = team ? team.permissions.some(function (_ref2) {
      var name = _ref2.name;
      return name === _Permissions.CHAT_FULL_ACCESS;
    }) : false;

    // Streaming/Recording status
    var isRecording = (0, _utils.getRecordingStatus)(liveRecordings);
    var isStreaming = (0, _utils.getStreamingStatus)(streamEndpoints);
    var streamRecordStatus = {
      isRecording: isRecording,
      isStreaming: isStreaming
    };
    var action = {
      type: _types.BROADCAST_GENERIC_APPROVE_ALL_KNOCKS,
      request: function () {
        var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(apiClient) {
          var requestPromises, approvedPresenterRequests;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                requestPromises = pendingKnocks.filter(function (_ref3) {
                  var type = _ref3.type;
                  return !(type === _Knocks.SCREENSHARE && !shouldApproveScreenshares);
                }).map(/*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref4) {
                    var _id, name, presenterId, type, attendeeId, sourceId, response, payload, knockPayload;
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.n) {
                        case 0:
                          _id = _ref4._id, name = _ref4.name, presenterId = _ref4.presenterId, type = _ref4.type, attendeeId = _ref4.attendeeId, sourceId = _ref4.sourceId;
                          _context.n = 1;
                          return apiClient.broadcastKnock.updateKnockRequest(teamId, eventId, broadcastId, _id, {
                            name: name,
                            presenterId: presenterId,
                            type: type,
                            status: _Knocks.ACCEPTED
                          });
                        case 1:
                          response = _context.v;
                          if (!(type === _Knocks.SCREENSHARE)) {
                            _context.n = 2;
                            break;
                          }
                          dispatch((0, _createOrUpdateSource["default"])({
                            sourceId: sourceId,
                            title: name,
                            type: _Sources.SCREEN_PRESENTER,
                            value: "".concat(attendeeId, "#content"),
                            description: ''
                          }));
                          payload = _objectSpread({
                            broadcastId: broadcastId,
                            attendeeId: attendeeId,
                            sourceId: sourceId
                          }, response);
                          socket.emit(_SocketEvents.DIRECTOR_REQUEST_ANSWER, payload);
                          return _context.a(2, response);
                        case 2:
                          knockPayload = {
                            broadcastId: broadcastId,
                            socketId: response.socketId,
                            knockId: response._id,
                            attendeeRoster: attendeeRoster,
                            program: program,
                            hasChatAccess: hasChatAccess,
                            muteMeetingAudio: broadcastSettings.muteMeetingAudio || false,
                            presenterBanner: presenterBanner,
                            broadcastSettings: broadcastSettings,
                            sourceId: sourceId,
                            streamRecordStatus: streamRecordStatus
                          };
                          socket.emit(_SocketEvents.KNOCK_ANSWER, knockPayload);
                          return _context.a(2, response);
                      }
                    }, _callee);
                  }));
                  return function (_x2) {
                    return _ref5.apply(this, arguments);
                  };
                }());
                _context2.n = 1;
                return Promise.all(requestPromises);
              case 1:
                approvedPresenterRequests = _context2.v;
                dispatch((0, _index.clearKnock)(approvedPresenterRequests));
                return _context2.a(2, approvedPresenterRequests);
            }
          }, _callee2);
        }));
        function request(_x) {
          return _request.apply(this, arguments);
        }
        return request;
      }()
    };
    return dispatch(action);
  };
};
var _default = exports["default"] = approveAllKnocks;